import { render, staticRenderFns } from "./PageOrders.vue?vue&type=template&id=60929117&scoped=true&"
import script from "./PageOrders.vue?vue&type=script&lang=ts&"
export * from "./PageOrders.vue?vue&type=script&lang=ts&"
import style0 from "./PageOrders.vue?vue&type=style&index=0&id=60929117&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60929117",
  null
  
)

export default component.exports